export default __webpack_public_path__ + "static/media/currencyconverter.cfa847a7.png";